export default function Image({ data, ...props }) {
  const {
    file: { url: imgSrc, title: imgAlt },
  } = data.fields;

  return <img src={imgSrc} alt={imgAlt} {...props} />;
}
